import {
  GET_DRIVER_ID_REQUEST,
  GET_DRIVER_ID_SUCCESS,
  GET_DRIVER_DATA_REQUEST,
  GET_DRIVER_DATA_SUCCESS,
  GET_DRIVER_ERROR,
  ADD_TO_BLACKLIST_REQUEST,
  ADD_TO_BLACKLIST_ERROR,
  ADD_TO_BLACKLIST_SUCCESS,
  CLEAR_DRIVER_FIELD,
  GET_DRIVER_AND_TRANSPORT_DATA_REQUEST,
} from './constants';
import { Actions } from './actions';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,

  loadFaceID: false as boolean,
  fieldFaceID: '' as string,
  errorFaceID: null as Error | null,
};

export type TripState = typeof initialState;

export const tripReducer = (state: TripState = initialState, action: Actions) => {
  switch (action.type) {
    case ADD_TO_BLACKLIST_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case ADD_TO_BLACKLIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case ADD_TO_BLACKLIST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case GET_DRIVER_ID_REQUEST: {
      return {
        ...state,
        fieldFaceID: action.field,
        loadFaceID: true,
        errorFaceID: null,
      };
    }
    case GET_DRIVER_ID_SUCCESS: {
      return {
        ...state,
        fieldFaceID: action.payload,
        loadFaceID: true,
        errorFaceID: null,
      };
    }
    case GET_DRIVER_DATA_REQUEST: {
      return {
        ...state,
        loadFaceID: true,
        errorFaceID: null,
      };
    }
    case GET_DRIVER_AND_TRANSPORT_DATA_REQUEST: {
      return {
        ...state,
        loadFaceID: true,
        errorFaceID: null,
      };
    }
    case GET_DRIVER_ERROR: {
      return {
        ...state,
        loadFaceID: false,
        errorFaceID: action.payload,
      };
    }
    case GET_DRIVER_DATA_SUCCESS: {
      return {
        ...state,
        loadFaceID: false,
        errorFaceID: null,
      };
    }
    case CLEAR_DRIVER_FIELD: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
